import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import http from "@/lib/api";
import { Panel, Table, Td, Empty, StatusBadge, fmt } from "./AdminKit";

export default function AdminSubmissions() {
  const [rows, setRows] = useState([]);
  const load = () => http.get("/v1/admin/submissions").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const markProcessed = async (id) => {
    try { await http.post(`/v1/admin/submissions/${id}/processed`); toast.success("Отмечено как обработано"); load(); } catch { toast.error("Ошибка"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-submissions">
      <h1 className="text-2xl font-bold text-white">Заявки на сдачу (Innleveringer)</h1>
      <Panel title={`Всего: ${rows.length}`}>
        {rows.length === 0 ? <Empty /> : (
          <Table head={["Заказ", "Клиент", "Телефон", "Машина", "Пакет", "Проблема", "Статус", "Дата", "Действия"]}>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-slate-700/50" data-testid={`submission-row-${r.id}`}>
                <Td>{r.order_id
                  ? <Link to={`/admin/reparasjoner?open=${r.order_id}`} className="text-blue-300 underline" data-testid={`submission-open-${r.id}`}>{r.order_number || "Открыть"}</Link>
                  : "—"}</Td>
                <Td>{r.customer_name}</Td>
                <Td>{r.customer_phone}</Td>
                <Td>{[r.machine_brand, r.machine_model].filter(Boolean).join(" ")}</Td>
                <Td>{r.selected_package}</Td>
                <Td className="max-w-xs whitespace-pre-wrap">{r.fault_description}</Td>
                <Td><StatusBadge value={r.status} /></Td>
                <Td>{fmt(r.created_at)}</Td>
                <Td>{r.status !== "processed" && (
                  <button onClick={() => markProcessed(r.id)} data-testid={`submission-processed-${r.id}`}
                    className="px-2.5 py-1 rounded bg-slate-700 hover:bg-slate-600 text-slate-100 text-xs whitespace-nowrap">Обработано</button>
                )}</Td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
